(ns dashboard.components.questionnaire.question-filter-popup
  (:require [dashboard.entity.question.db :as questions.db]
            [dashboard.subs :as common-subs]
            [io.repliance.ui.util :refer [is-descendant-of?]]
            [re-frame.core :as rf]
            [react]))

(defn question-filter-popup [{:keys [questionnaire-id template-questionnaire?]}]
  (let [filters @(questions.db/filters* questionnaire-id)
        toggle-status-filter (fn [status value]
                               (questions.db/set-filters questionnaire-id
                                                         {(str "status/" status) value}))
        [ref set-ref] (react/useState nil)
        features-enabled @(rf/subscribe [::common-subs/features-enabled])]
    (react/useEffect (fn []
                       (let [click-handler (fn [e]
                                             (when-not (is-descendant-of? (.-target e) ref)
                                               (questions.db/set-filter-popup-visibility false)))]
                         (js/document.addEventListener "click" click-handler)
                         (fn []
                           (js/document.removeEventListener "click" click-handler))))
                     (array ref))
    [:div {:style {:width 0 :height 0}}
     [:div.card.has-background-white
      {:ref set-ref
       :style {:position "absolute"
               :right 0
               :margin-right "3rem"
               :margin-top "-1rem"
               :z-index 999
               :border-color "black"
               :border-style "solid"
               :width "256px"}}
      [:header.card-header.is-shadowless
       [:p.card-header-title.is-size-5 "Filters"]
       [:button.card-header-icon.is-medium
        {:on-click #(questions.db/set-filter-popup-visibility false)}
        [:span.icon>i.fas.fa-circle-xmark]]]
      [:div.card-content.px-4.is-flex.is-flex-direction-column.is-align-items-flex-start
       (when (and (contains? features-enabled :applied-analysis-creation)
                  (not template-questionnaire?))
         [:<>
          [:b "Status"]
          [:label.checkbox.py-2
           [:input {:type "checkbox"
                    :checked (get filters "status/approved" false)
                    :on-change #(toggle-status-filter "approved" (.. % -target -checked))}]
           [:span.icon.has-text-success.is-medium.ml-4.mr-2>i.fas.fa-lg.fa-check-circle]
           "Approved"]
          [:label.checkbox.py-2
           [:input {:type "checkbox"
                    :checked (get filters "status/in-review" false)
                    :on-change #(toggle-status-filter "in-review" (.. % -target -checked))}]
           [:span.icon.has-text-warning.is-medium.ml-4.mr-2>i.fas.fa-lg.fa-question-circle]
           "In-review"]
          [:label.checkbox.py-2
           [:input {:type "checkbox"
                    :checked (get filters "status/unknown" false)
                    :on-change #(toggle-status-filter "unknown" (.. % -target -checked))}]
           [:span.icon.has-text-danger.is-medium.ml-4.mr-2>i.fas.fa-lg.fa-times-circle]
           "Unknown"]])

       [:b.mt-2 "Other"]
       [:label.checkbox.py-2
        [:input {:type "checkbox"
                 :checked (get filters "unread-notes" false)
                 :on-change #(questions.db/set-filters
                              questionnaire-id
                              {"unread-notes" (.. % -target -checked)})}]
        [:span.icon.is-medium.ml-4.mr-2>i.fas.fa-lg.fa-comment]
        "Unread notes"]

       [:button.button.is-rounded.is-primary.is-fullwidth.mt-4
        {:on-click #(questions.db/clear-filters questionnaire-id)
         :title "Clear selected filters"}
        "Clear Filters"]]]]))
